module.exports = __webpack_public_path__ + "img/hiw.b6fbfe6b.png";